import AcceptOnlineMeeting from './AcceptOnlineMeeting'

export default AcceptOnlineMeeting
